/* eslint-disable react/no-this-in-sfc */
/* eslint-disable react/prop-types */
/* eslint-disable no-unused-vars */
import React, { useRef, useEffect, useState } from "react";
import Highcharts from "highcharts";
// import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
// import { DatePicker } from '@mui/x-date-pickers/DatePicker';
// import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
// import { TextField } from '@mui/material';
import dayjs from "dayjs";
// import DatePicker from 'react-datepicker';
// import 'react-datepicker/dist/react-datepicker.css';
import "./styles.css";
// import Calender from '../../../assets/Vector/SelectCalendar.svg';

function PaymentGatewayBarChart({
  paymentGatewayData,
  handleDateChange,
  selectedDate,
}) {
  const chartContainer = useRef(null);
  // console.log(paymentGatewayData);

  useEffect(() => {
    // const currentDate = new Date();
    // const daysInMonth = new Date(currentDate.getFullYear(), currentDate.getMonth() + 1, 0).getDate();
    const gateways = paymentGatewayData.map((gateway) => ({
      name: gateway.gatewayType,
      y: Number(gateway.sum),
      // z: Math.random(),
      z: gateway.receiptCount || 0,
    }));
    // console.log(contributionData);
    // Create the chart
    Highcharts.chart(chartContainer.current, {
      chart: {
        type: "column",
      },
      title: {
        text: null,
        // align: 'left',
        // style: {
        //     color: '#585858',
        //   },
      },
      //   subtitle: {
      //     text: 'National Level',
      //     align: 'left',
      //     style: {
      //       color: '#444',
      //     },
      //   },
      xAxis: {
        type: "category",
        title: {
          text: "Payment Gateway",
        },
      },
      yAxis: {
        title: {
          text: "Contribution Amount ₹ ",
        },
      },
      tooltip: {
        // formatter: function() {
        //   return `Payment Gateway: <b>${(this.point.name)}</b><br/>Amount: <b>₹ ${Math.round(this.y)}</b>`;
        // }
        formatter() {
          return `Payment Gateway: <b>${
            this.point.name
          }</b><br/>Amount: <b>₹ ${Math.round(this.y).toLocaleString(
            "en-IN",
          )}</b><br>Number of Receipts: <b>${this.point.z.toLocaleString(
            "en-IN",
          )}</b>`;
        },
      },
      series: [
        {
          name: "Contributions",
          data: gateways,
          color: {
            linearGradient: { x1: 0, x2: 0, y1: 0, y2: 1 },
            stops: [
              [0, "#A63EB6"],
              [1, "#B33F99"],
            ],
          },
        },
      ],
    });
  }, [paymentGatewayData]);

  return (
    <div
      style={{ background: "#fff", paddingTop: "20px", borderRadius: "12px" }}
    >
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "flex-end", // Align items to the right
          paddingRight: "24px",
          marginBottom: "24px",
        }}
      >
        {/* <LocalizationProvider dateAdapter={AdapterDayjs}>
          <DatePicker
            label="Select Month"
            value={selectedDate}
            openTo="month"
            onChange={(newDate) => handleDateChange(newDate)}
            disableFuture
            renderInput={(params) => <TextField {...params} />}
            views={["year", "month"]} // Show only year and month
            format="MMMM YYYY" // Format for display
            slotProps={{ textField: { size: "small" } }}
            sx={{ width: "190px", height: "46px", marginTop: "24px" }}
          />
        </LocalizationProvider> */}
      </div>
      <div
        ref={chartContainer}
        style={{ borderRadius: "12px", overflow: "hidden" }}
      />
    </div>
  );
}

export default PaymentGatewayBarChart;
